import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import AdvancedResults from '../../components/AdvancedResults';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const AdvancedSearchPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        <AdvancedResults />
      </main>
      <LoginFooter />
    </>
  )
}

export default AdvancedSearchPage;